__turbopack_context__.v({
  "container": "ShoppingCart-module-scss-module__Ei0Cva__container",
});
